import { useEffect } from 'react'
import { API_BASE } from '../lib/api'
import { useAuthStore } from '../stores/authStore'
import { useThemeStore } from '../stores/themeStore'

/** Headless component that applies the current theme on mount and fetches site/user theme preferences. */
export default function ThemeInitializer() {
    const applyTheme = useThemeStore(s => s.applyTheme)
    const setSiteDefaults = useThemeStore(s => s.setSiteDefaults)
    const token = useAuthStore(s => s.accessToken)

    useEffect(() => {
        // Apply whatever's in localStorage immediately
        applyTheme()

        // Then fetch site defaults from the API
        fetch(API_BASE + '/api/settings/theme')
            .then(r => r.ok ? r.json() : null)
            .then(data => {
                if (data?.theme && data?.colorMode) {
                    setSiteDefaults(data.theme, data.colorMode)
                }
            })
            .catch(() => { /* use local defaults */ })
    }, []) // eslint-disable-line react-hooks/exhaustive-deps

    // When user logs in, fetch their preferences
    useEffect(() => {
        if (!token) return
        fetch(API_BASE + '/api/me/preferences', {
            headers: { Authorization: `Bearer ${token}` }
        })
            .then(r => r.ok ? r.json() : null)
            .then(data => {
                if (data) {
                    const store = useThemeStore.getState()
                    if (data.preferredTheme) store.setTheme(data.preferredTheme)
                    if (data.preferredColorMode) store.setColorMode(data.preferredColorMode)
                }
            })
            .catch(() => { /* use local/site defaults */ })
    }, [token])

    return null
}
